import { render } from "./subheader-profile.vue?vue&type=template&id=201e5a77"
import script from "./subheader-profile.vue?vue&type=script&lang=js"
export * from "./subheader-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__